var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { forwardIconRef } from "../../lib/icons";
var SearchCloseIcon = forwardIconRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, props),
    React.createElement("g", { transform: "translate(-1142 -65)" },
        React.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "#b2b3b8", transform: "translate(1142 65)" }),
        React.createElement("path", { fill: "#fff", d: "M1152 75.808l3.024 3.024a.57134228.57134228 0 10.808-.808L1152.808 75l3.024-3.024a.57134228.57134228 0 00-.808-.808L1152 74.192l-3.024-3.024a.57134228.57134228 0 10-.808.808l3.024 3.024-3.024 3.024a.57134228.57134228 0 10.808.808z" })))); });
export default SearchCloseIcon;
